var $ = jQuery.noConflict();
var styleSelect = require('styleSelect');

let currentPage = 1;
let selectedTaxes = {}

$(document).ready( function() {
  $('#clear-filters').hide();
  // Style selects with styleSelect.js
  const selects = document.querySelectorAll('select.styled-select');
  selects.forEach( select => {
    styleSelect( select );
  });

  $('.filter-tax select, .filter-date select').on('change', function () {
    // Reset selected taxes
    selectedTaxes = {}
    // Reset current page
    currentPage = 1
console.log('hi')
    filterByTaxes(selectedTaxes)
    let showClear = false;

    $('.filter-tax select, .filter-date select').each(function(){
      if ($(this).val() != '') {
        showClear = true;
      }
    })

    if ( showClear ) {
      $('#clear-filters').fadeIn();
    } else {
      $('#clear-filters').fadeOut();
    }
    // $( 'option:selected', this )
  });


  $('#clear-filters').on('click', function(){
    console.log($('.filter-tax select, .filter-date select'));
    $('.ss-dropdown').each(function(){
      $(this).children().eq(0).click();
    });
    if($(window).width()<768){
        console.log("this is in the mobile loop");
    $('.styled-select').each(function(i,x){
        $(this).val("");
        console.log();
        $(this).trigger('change');
    });
  }

  }).keypress(function(){
    $(this).trigger('click');
  });


  $('.more-posts').on('click', function() {
    currentPage++
    filterByTaxes(selectedTaxes)
  })

})

function filterByTaxes(selectedTaxes) {
  $('.loading').toggleClass('active')
  // Iterate through all tax filters and find selected terms
  var url = document.location.origin + document.location.pathname
  $('.filter-tax').each( function() {
    if ( $(this).find('select').val() !== '' ) {
      console.log($(this).find('select').val());
      var selectedTax = $('select', this).attr('name')
      var selectedTerm = $(this).find('select').val();
      selectedTaxes[selectedTax] = selectedTerm
      if ( url.indexOf('?') !== -1 ) {
        url += `&${selectedTax}=${selectedTerm}`
      } else {
        url += `?${selectedTax}=${selectedTerm}`
      }
    }
  })
  console.log(selectedTaxes);
  window.history.pushState("","", url);

  // Filter date
  let filterDate = null
  if ( $('.filter-date').length && $('.filter-date option:selected').val() !== '' ) {
    filterDate = $('.filter-date option:selected').val()
  }

  let mediaKits = "false";

  if ( $('#shift-filter').hasClass('has-media-kits') ) {
    mediaKits = "true";
  }

  let resourceType = "false";

  if ( $('.more-posts span').get(0).hasAttribute('data-resource-type') ) {
    resourceType = "true";
  }

  console.log("hi", mediaKits);

  const data = {
    'action': 'shift_filter_ajax',
    'fn' : 'shift_filter',
    'ptype' : 'resource',
    'taxes' : selectedTaxes,
    'paged' : currentPage,
    'date' : filterDate,
    'mediaKits' : mediaKits,
    'resourceType' : resourceType
  };

  console.log(data);

  $.ajax({
    url: ajaxurl,
    method: 'post',
    type: 'json',
    data: data
  }).done( function (data) {
    // Clear posts if refreshed list
    if ( currentPage === 1 ) {
      $('#shift-filter-posts').empty()
    }
    if(data) {
      console.log(data)
      $('.loading').toggleClass('active')
      var response = JSON.parse(data)
      if ( response.posts ) {
        $('#shift-filter-posts').append(response.posts)
        if ( response.maxpages <= currentPage ) {
          $('.more-posts').addClass('hidden')
        } else {
          $('.more-posts').removeClass('hidden')
        }
      } else {
        // No posts to display
      }
    }
  });
}
